import React from "react"
import styled from "styled-components"
import { ListItem } from "./ListItem"
import { data } from "../data"

const OrderedList = styled.ol`
  list-style-type: decimal;
  list-style-position: outside;
  padding: 0;
  margin: 0;
`

export default function ContentList() {
  return (
    <OrderedList>
      {data.map((item, index) => (
        <ListItem
          key={index}
          title={item.title}
          content={item.content}
          itemList={item.itemList || null}
          itemHeading={item.itemHeading || null}
          itemNote={item.itemNote || null}
        />
      ))}
    </OrderedList>
  )
}
